import MenuOverflow from "./Menu/MenuOverflow";
import MenuDropdown from "./Menu/Dropdown/Menu.dropdown";

const NavigationDemo = {

    init() {
        this.el = $('[template="Sitelab"] [container="playground"][content="Navigation"]');
        if (!this.el.length) return;

        this.form = this.el.find('form');
        this.preview = this.el.find('[module]');
        this.bind();
    },

    bind() {
        this.form.find('input[type]').not('input[type="checkbox"]').change((evt) => {
            this.set($(evt.currentTarget));
        })

        this.form.find('select').change((evt) => {
            this.set($(evt.currentTarget));
        })

        this.form.find('input[type="checkbox"]').change((evt) => {
            this.set($(evt.currentTarget), $(evt.currentTarget).prop('checked'));
        })
    },

    set(input, val) {
        const property = input.attr('id');
        const value = val !== undefined ? val : input.val()
        // console.log(input, property, value, val)

        this.preview.attr(property, value);
        this.render(this.preview, this.afterRender, this);
    },

    render(jQuerySelection, callback, scope) {
        jQuerySelection.addClass('loading');
        (jQuerySelection || $('sb\\:module'))
            .each(function () {
                var element = $(this);
                var html = element.clone().empty().wrap('<div>').parent().html();
                $.ajax({
                    method: 'POST',
                    url: WEB_ROOT + '/sitelab/page?action=renderContent',
                    data: html,
                    dataType: 'html',
                    success: function (responseHTML) {
                        element.empty();
                        element.html($(responseHTML).html());
                        element.removeClass('loading');
                        callback && callback.call(scope || this, element);
                    }
                });
            });
    },

    afterRender() {
        MenuOverflow.resize();
        if(!this.el.length) return;
        MenuDropdown.init(this.preview);
    },
}

export default NavigationDemo;